<template>
	<div class="app-body">
		<div class="a-flex-rsbc a-ptb-6">
			<span class="a-fs-16">供应列表</span>
			<!-- <el-button icon="el-icon-upload2" class="s-btn-exp">导出</el-button> -->
		</div>

		<el-card class="el-main">
			<le-search-form id="leSearch" @reset="handlerRest" @search="handlerSearch">
                <le-select-local-search label="供应类型" v-model="pageParam.params.businessType" :options="businessTypeDic" />
				<le-input label="供应名称" v-model="pageParam.params.title" placeholder="请输入内容" />
                <le-select-local-search label="状态" v-model="pageParam.params.statusList" :options="statusDic" multiple />
                <le-input-district-choose label="省市区" :province.sync="pageParam.params.provinceCode" :city.sync="pageParam.params.cityCode" :area.sync="pageParam.params.districtCode"></le-input-district-choose>
                <le-input label="发布人电话" v-model="pageParam.params.publisherPhone" placeholder="请输入内容" />
                <le-date-range 
                    label="发布时间" 
                    :minDate.sync="pageParam.params.startTime" 
                    :maxDate.sync="pageParam.params.endTime" 
                    :defaultTime="['00:00:00','23:59:59']"
                    valueFormat="yyyy-MM-dd HH:mm:ss" />
			</le-search-form>
			<le-pagview @setData="setTableData" :pageParam="pageParam" ref="supplyPage" :isFixed="true" :tableRef="$refs.supplyList">
				<el-table :data="tableData" :highlight-current-row="true" ref="supplyList" v-sticky="{ top: 0, parent:'.el-card__body' }">
                    <!-- 发布类型 -->
                    <el-table-column prop="businessType" label="供应类型">
                        <template slot-scope="{ row }">
                            <span>{{ row.businessType | initDic(businessTypeDic) }}</span>
                        </template>
                    </el-table-column>

                    <!-- 供应名称 -->
                    <el-table-column prop="title" label="供应名称">
                        <template slot-scope="{ row }">
                            <span>{{ row.title }}</span>
                        </template>
                    </el-table-column>

                    <!-- 供应量 -->
                    <el-table-column prop="amount" label="供应量">
                        <template slot-scope="{ row }">
                            <span>{{ row.amount }}{{ row.unit || '' }}</span>
                        </template>
                    </el-table-column>

                    <!-- 描述 -->
                    <el-table-column prop="description" label="描述" width="200">
                        <template slot-scope="{ row }">
                            <div class="a-flex-rfsc">
                                <span style="width: 140px;" class="textOver1">{{ row.description }}</span>
                                <el-tooltip placement="top">
                                    <div slot="content" style="width: 300px;">{{ row.description }}</div>
                                    <el-button type="text">查看</el-button>
                                </el-tooltip>
                            </div>
                        </template>
                    </el-table-column>

                    <!-- 图片附件 -->
                    <el-table-column prop="imageUrls" label="图片附件" min-width="140">
                        <template slot-scope="{ row }">
                            <div v-if="row.imageUrls && getImageList(row.imageUrls).length > 0" class="image-attachment">
                                <el-image 
                                    :src="getImageList(row.imageUrls)[0]" 
                                    :preview-src-list="getImageList(row.imageUrls)"
                                    fit="cover"
                                    style="width: 80px; height: 80px;border-radius: 6px">
                                </el-image>
                                <span class="image-count a-ml-10">{{ getImageCount(row.imageUrls) }}张</span>
                            </div>
                        </template>
                    </el-table-column>

                    <!-- 状态 -->
                    <el-table-column prop="status" label="状态">
                        <template slot-scope="{ row }">
                            <span :class="['status-tag', getStatusClass(row.status)]">
                                {{ row.status | initDic(statusDic) }}
                            </span>
                        </template>
                    </el-table-column>

                    <!-- 查看/收藏/意向 -->
                    <el-table-column prop="viewCount" label="查看/收藏/联系">
                        <template slot-scope="{ row }">
                            <div class="a-flex-rfsc" @click="editPageViews(row)">
                                <span>{{ row.viewCount || 0 }}/{{ row.collectionCount || 0 }}/{{ row.intentionCount || 0 }}</span>
                                <i class="el-icon-edit a-c-blue a-fs-16 a-fw-700 a-ml-10"></i>
                            </div>
                        </template>
                    </el-table-column>

                    <!-- 供应地区 -->
                    <el-table-column prop="provinceName" label="供应地区">
                        <template slot-scope="{ row }">
                            <span>{{ formatRegion(row.provinceName, row.cityName, row.districtName) }}</span>
                        </template>
                    </el-table-column>

                    <!-- 供应截止日期 -->
                    <el-table-column prop="validityEndTime" label="供应截止日期">
                        <template slot-scope="{ row }">
                            <span v-if="row.validityType == 1">长期</span>
                            <span v-else-if="row.validityType == 2">{{ row.validityEndTime }}</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>

                    <!-- 发布人 -->
                    <el-table-column prop="publisherName" label="发布人">
                        <template slot-scope="{ row }">
                            <span>{{ row.publisherName }} {{ row.publisherPhone }}</span>
                        </template>
                    </el-table-column>

                    <!-- 发布时间 -->
                    <el-table-column prop="publishTime" label="发布时间">
                        <template slot-scope="{ row }">
                            <span>{{ row.publishTime }}</span>
                        </template>
                    </el-table-column>

                    <!-- 操作 -->
                    <el-table-column label="操作" width="160" fixed="right">
                        <template slot-scope="{ row }">
                            <el-button type="text" v-if="row.status === 1" @click="handleAudit(row)">审核</el-button>
                            <el-button type="text" @click="handleIntentRecord(row)">联系记录</el-button>
                            <el-button type="text" v-if="row.status !== 5" @click="handleOffline(row)">下线</el-button>
                        </template>
                    </el-table-column>
                </el-table>
			</le-pagview>
		</el-card>
        <PageViewsEdit 
            :publishType="2"
            :visible.sync="isEditDialogVisible" 
            :initial-data="{
                viewCount: currentEditRow.viewCount || 0,
                collectionCount: currentEditRow.collectionCount || 0,
                intentionCount: currentEditRow.intentionCount || 0
            }"
            @submit="handlePageViewsSubmit"
        />
        <AuditDialog 
            :visible.sync="isAuditDialogVisible" 
            @submit="handleAuditSubmit"
        />
	</div>
</template>

<script>
import util from "../../utils/util.js";
import PageViewsEdit from '../demand/components/pageViews-edit.vue';
import AuditDialog from '../demand/components/audit-dialog.vue';
export default {
    components: {
        PageViewsEdit,
        AuditDialog
    },

	data() {
		return {
			util: util,
			businessTypeDic: [],
            statusDic: [],
			tableData: [],
            // 3. 添加控制弹窗显示的状态
            isEditDialogVisible: false,
            // 4. 添加当前编辑行的数据
            currentEditRow: {}, 
            isAuditDialogVisible: false,
            currentAuditRow: {},
			pageParam: {
				url: this.$Config.apiUrl.supplyBackPage,
				method: "post",
				params: {
                    businessType: "",
					publishType: "2",
                    title: "",
                    statusList: [],
                    provinceCode: "",
                    cityCode: "",
                    districtCode: "",
                    publisherPhone: "",
                    startTime: "",
                    endTime: "",
				},
                freshCtrl: 1,
			},
		}
	},
    created () { 
        this.$getDic('supplyBusinessType','select').then(res=>{ this.businessTypeDic = res; })
        this.$getDic('supplyStatus','select').then(res=>{ this.statusDic = res; })
    },
    activated () {
        this.pageParam.freshCtrl++; 
    },
	methods: {
        // 获取供应列表
        setTableData(data) {
            this.tableData = data;
        },

        // 获取图片数量
        getImageCount(imageUrls) {
            if (!imageUrls) return 0;
            try {
                const images = JSON.parse(imageUrls);
                return Array.isArray(images) ? images.length : 0;
            } catch (e) {
                return 0;
            }
        },

        // 获取图片列表
        getImageList(imageUrls) {
            if (!imageUrls) return [];
            try {
                const images = JSON.parse(imageUrls);
                return Array.isArray(images) ? images : [];
            } catch (e) {
                return [];
            }
        },

        // 获取状态文本
        getStatusText(status) {
            const statusMap = {
                1: '待审核',
                2: '审核驳回',
                3: '需求中',
                4: '已完成',
                5: '已下线'
            };
            return statusMap[status] || '未知';
        },

        // 获取状态样式类
        getStatusClass(status) {
            const classMap = {
                1: 'pending',
                2: 'rejected',
                3: 'active',
                4: 'completed',
                5: 'offline'
            };
            return classMap[status] || '';
        },

        // 格式化地区显示
        formatRegion(provinceName, cityName, districtName) {
            const parts = [provinceName, cityName, districtName].filter(Boolean);
            return parts.join('') || '全国';
        },

        handlerRest() {
			this.pageParam.params = {
                businessType: "",
                publishType: "2",
                title: "",
                statusList: [],
                provinceCode: "",
                cityCode: "",
                districtCode: "",
                publisherPhone: "",
                startTime: "",
                endTime: "",
			};
			this.handlerSearch()
		},
		handlerSearch() {
			this.$refs['supplyPage'].pageNum = 1
			this.pageParam.freshCtrl++;
		},

        // 审核操作
        handleAudit(row) {
            this.currentAuditRow = row;
            this.isAuditDialogVisible = true;
        },

        handleAuditSubmit(data) {
            this.$Axios._post({
                url: this.$Config.apiUrl.supplyBackAudit,
                method: 'post',
                params: {
                    id: this.currentAuditRow.id,
                    auditStatus: data.auditStatus,
                    auditRemark: data.auditRemark
                }
            }).then(() => {
                this.$message.success('审核成功');
                // 刷新列表
                this.pageParam.freshCtrl++;
            }).catch(() => {
                this.$message.error('审核失败');
            });
        },

        // 联系记录操作
        handleIntentRecord(row) {
            this.$router.push({
                name: 'contract-list', // 请确保路由表中存在此 name
                query: {
                    supplyId: row.id
                }
            });
        },

        // 下线操作
        handleOffline(row) {
            this.$confirm('确定要下线该供应吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$Axios._post({
                    url: this.$Config.apiUrl.supplyBackOffline,
                    method: 'post',
                    params: {
                        id: row.id
                    }
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '下线成功!'
                    });
                    // 刷新列表
                    this.pageParam.freshCtrl++;
                }).catch(() => {
                    this.$message({
                        type: 'error',
                        message: '下线失败!'
                    });
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消下线'
                });
            });
        },

        // 编辑浏览留
        editPageViews (row) {
            this.currentEditRow = row;
            this.isEditDialogVisible = true;
        },
        // 6. 处理弹窗提交事件
        handlePageViewsSubmit(data) {
            this.$Axios._post({
                url: this.$Config.apiUrl.supplyBackEditCount,
                method: 'post',
                params: {
                    supplyDemandId: this.currentEditRow.id,
                    viewIncrement: data.viewCount,
                    collectionIncrement: data.collectionCount,
                    contactIncrement: data.intentionCount
                }
            }).then(() => {
                this.$message.success('更新成功');
                // 刷新列表
                this.pageParam.freshCtrl++;
            }).catch(() => {
                this.$message.error('更新失败');
            });
        },
    }
};
</script>

<style scoped lang="scss">
.image-attachment {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.preview-image {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transform: scale(1.05);
  }
  
  /deep/ .el-image__inner {
    border-radius: 4px;
  }
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 24px;
}

.image-count {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.status-tag {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.status-tag.pending {
  background-color: #f5f5f5;
  color: #999;
}

.status-tag.rejected {
  background-color: #fef0f0;
  color: #f56c6c;
}

.status-tag.active {
  background-color: #e1f3d8;
  color: #67c23a;
}

.status-tag.completed {
  background-color: #e6f7ff;
  color: #1890ff;
}

.status-tag.offline {
  background-color: #f4f4f5;
  color: #909399;
}

.el-button--mini {
  padding: 4px 8px;
  font-size: 12px;
}

/* 操作按钮间距 */
.el-button + .el-button {
  margin-left: 8px;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
    /*width: 0;宽度为0隐藏*/
    width: 0 !important;
    height: 0 !important;
}
/deep/ .el-table__fixed, /deep/ .el-table__fixed-right{
    height: 100% !important;
}